import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Materialcatalog.scss";

//Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";

const ProductArticle = () => {
  localStorage.setItem("menu", "Product Matrix");
  localStorage.setItem("submenu", "Product Hierarchy");

  // const activeOptions = [
  //   { id: 1, name: "Yes", textField: "type" },
  //   { id: 2, name: "No", textField: "type" },
  // ]

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };

  const categories1 = [
    {
      name: "All",
      key: "All",
      children: [
        {
          name: "Fashion",
          key: "Fashion",
          children: [
            {
              name: "MensWear",
              key: "MensWear",
              children: [
                { name: "Casual Shirts", key: "Casual_Shirts" },
                { name: "Coats & Jackets", key: "Coats_Jackets" },
                { name: "Dress Shirts", key: "Dress_Shirts" },
              ],
            },
            {
              name: "KidsWear",
              key: "KidsWear",
              children: [
                { name: "Kids Dress", key: "Kids_Dress" },
                { name: "Kids Accessories", key: "Kids_Accessories" },
              ],
            },
            {
              name: "WomensWear",
              key: "WomensWear",
              children: [
                { name: "Womens Dresses", key: "Womens_Dresses" },
                { name: "Womens Accessories", key: "Womens_Accessories" },
              ],
            },
          ],
        },
        {
          name: "Kitchen",
          key: "kitchen",
          children: [
            {
              name: "Cookware",
              key: "cookware",
              children: [
                { name: "Cookware", key: "Cookware" },
                { name: "Kitchen Storage", key: "Kitchen_Storage" },
                { name: "Small Appliances", key: "Small_Appliances" },
              ],
            },

          ],
        },
        {
          name: "Garden",
          key: "garden",
          children: [
            {
              name: "GardenCategory",
              key: "gardenCategory",
              children: [
                { name: "Garden Tools", key: "Garden_Tools" },
                { name: "Plants & Seeds", key: "Plants_Seeds" },
                { name: "Outdoor Furniture", key: "Outdoor_Furniture" },
              ],
            },

          ],
        },
      ],
    },

  ];

  const [openCategories, setOpenCategories] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  // console.log(">>selectedItem", selectedItem)

  const handleToggle = (name) => {
    setOpenCategories((prev) =>
      prev.includes(name)
        ? prev.filter((n) => n !== name)
        : [...prev, name]
    );
  };

  const handleItemClick = (item) => {
    if (!item.children) {
      setSelectedItem(product[item.key] || {
        name: item.name,
        description: "No details found.",
      });
    }
  };


  const product = {
    Casual_Shirts: {

      activatedDate: "2025-01-15",
      commodityCode: "CSH-1001",
      generalDescription: "Comfortable cotton casual shirt for men.",
      searchText: "casual shirt men cotton",
      organisationName: "Casual Shirts",
      active: "Yes",
      modifiedDate: "2025-01-15",
      friendlyName: "Casual Shirts",

      variantGroups: "Basic Fit",
      washAndCare: "Machine wash cold, do not bleach",
      matrixLayout: "Yes",
      showColors: "Vertical",
      colorGroup: "Blue Shades",
      productBrands: "UrbanMan",
      showSizes: "Horizental",
      showFiles: "NONE",
      sizeCurve: "M-L-XL",
      colorCurve: "Light-Dark",
      fitGroup: "Regular",
      ratioCurves: "Yes",
      fitCurve: "Standard Fit",

      legalEntity: "Vinay Fashion Ltd",
      variant: "No",
      barCode: "No",
      posRegister: "POS-001",
      matrixItemCoverage: "Storewide",
      seasons: "Summer 2025",
      comparisonPrice: "$45.00",
      identification: "C-SHRT-XL-BLUE",
      itemNumber: "CSH1001-BLXL",
      product: "Casual Shirt",
      productType: "Apparel",
      productSubType: "Shirt",
      retailCategory: "Menswear",
      porductBrands: "UrbanMan",
      purchase: "Yes",
      inventory: "In Stock",
      sales: "Available",
      recomended: "Top Seller"

    },
    Coats_Jackets: {
      activatedDate: "2025-02-10",
      commodityCode: "JK-2011",
      generalDescription: "Winter wear jacket with fur lining.",
      searchText: "winter jacket warm fur",
      organisationName: "Vinay",
      active: "Yes",

      variantGroups: "Premium Fit",
      washAndCare: "Dry clean only",
      matrixLayout: "Yes",
      showColors: true,
      colorGroup: "Neutral",
      productBrands: "ArcticLine",
      showSizes: true,
      showFiles: false,
      sizeCurve: "S-M-L",
      colorCurve: "Beige-Grey",
      fitGroup: "Slim",
      ratioCurves: "Yes",
      fitCurve: "Tailored",

      legalEntity: "Vinay Clothing Co",
      variant: "No",
      barCode: "No",
      posRegister: "POS-002",
      matrixItemCoverage: "Online Only",
      seasons: "Winter 2025",
      comparisonPrice: "$110.00",
      identification: "JCKT-L-BEIGE",
      itemNumber: "JK2011-BGL",
      product: "Winter Jacket",
      productType: "Outerwear",
      productSubType: "Jacket",
      retailCategory: "Menswear",
      porductBrands: "ArcticLine",
      purchase: "Yes",
      inventory: "Limited Stock",
      sales: "Available",
      recomended: "Seasonal Pick"

    },
    Dress_Shirts: {
      activatedDate: "2025-03-05",
      commodityCode: "KDS-3012",
      generalDescription: "Kids colorful cotton dress with floral print.",
      searchText: "kids floral dress cotton",
      organisationName: "Vinay Kids",
      active: "Yes",

      variantGroups: "Kidswear",
      washAndCare: "Hand wash recommended",
      matrixLayout: "Yes",
      showColors: true,
      colorGroup: "Multicolor",
      productBrands: "TinyTrends",
      showSizes: true,
      showFiles: false,
      sizeCurve: "2-4-6-8 Years",
      colorCurve: "Bright Pastels",
      fitGroup: "Kids Regular",
      ratioCurves: "Yes",
      fitCurve: "Kids Comfort Fit",

      legalEntity: "Vinay Kidswear Pvt Ltd",
      variant: "No",
      barCode: "No",
      posRegister: "POS-003",
      matrixItemCoverage: "All Stores",
      seasons: "Spring 2025",
      comparisonPrice: "$30.00",
      identification: "KDS-DRS-4Y-PNK",
      itemNumber: "KDS3012-PNK4Y",
      product: "Kids Dress",
      productType: "Apparel",
      productSubType: "Dress",
      retailCategory: "Kidswear",
      porductBrands: "TinyTrends",
      purchase: "Yes",
      inventory: "In Stock",
      sales: "Available",
      recomended: "Trending"

    },
    Kids_Dress: {
      activatedDate: "2025-04-01",
      commodityCode: "WDR-4011",
      generalDescription: "Elegant women's evening dress with lace.",
      searchText: "evening dress lace elegant",
      organisationName: "Vinay",
      active: true,

      variantGroups: "Women's Fit",
      washAndCare: "Dry clean preferred",
      matrixLayout: "Yes",
      showColors: true,
      colorGroup: "Black & Red",
      productBrands: "Elegance",
      showSizes: true,
      showFiles: true,
      sizeCurve: "XS-S-M",
      colorCurve: "Red-Black",
      fitGroup: "Slim",
      ratioCurves: "Yes",
      fitCurve: "Body Fit",

      legalEntity: "Vinay Elegance Inc",
      variant: "No",
      barCode: "No",
      posRegister: "POS-004",
      matrixItemCoverage: "Flagship Stores",
      seasons: "Fall 2025",
      comparisonPrice: "$75.00",
      identification: "WOMDRS-M-RED",
      itemNumber: "WDR4011-REDM",
      product: "Evening Dress",
      productType: "Apparel",
      productSubType: "Dress",
      retailCategory: "Womenswear",
      porductBrands: "Elegance",
      purchase: "Yes",
      inventory: "In Stock",
      sales: "Available",
      recomended: "Editors Choice"
    },
  };


  const renderCategories = (categories) => {
    return (
      <ul className="ms-2">
        {categories.map((cat) => (
          <React.Fragment key={cat.name}>
            <li className="d-flex justify-content-between">
              <span className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                {cat.children ? (
                  <i
                    className={`bi bi-chevron-right me-2 ${openCategories.includes(cat.name) ? "rotate" : "still"
                      }`}
                    onClick={() => handleToggle(cat.name)}
                  ></i>
                ) : (
                  <span className="me-2"></span>
                )}

                <span onClick={() => handleItemClick(cat)}>{cat.name}</span>
              </span>
            </li>

            {cat.children && openCategories.includes(cat.name) && (
              <div className="ms-4">{renderCategories(cat.children)}</div>
            )}
          </React.Fragment>
        ))}
      </ul>
    );
  };

  /* ========================================================== */


  const [validation, /*setValidation*/] = useState({
    driverName: "",
  });
  const [formInputs, setFormInputs] = useState({
    activatedDate: "",
    commodityCode: "",
    generalDescription: "",
    searchText: "",
    organisationName: "",
    active: "",
    friendlyName: "",
    modifiedDate: "",
    variantGroups: "",
    washAndCare: "",
    matrixLayout: "",
    showColors: "",
    colorGroup: "",
    productBrands: "",
    showSizes: "",
    showFiles: "",
    sizeCurve: "",
    colorCurve: "",
    fitGroup: "",
    ratioCurves: "",
    fitCurve: "",
    legalEntity: "",
    variant: "",
    barCode: "",
    posRegister: "",
    matrixItemCoverage: "",
    seasons: "",
    comparisonPrice: "",
    identification: "",
    itemNumber: "",
    product: "",
    productType: "",
    productSubType: "",
    retailCategory: "",
    porductBrands: "",
    purchase: "",
    inventory: "",
    sales: "",
    recomended: "",
  });

  useEffect(() => {
    setFormInputs(selectedItem)
  }, [selectedItem])
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Product Hierarchy</h2>
            <p className="subText">Catalog </p>
            <hr />
            <Row>
              <Col
                lg={2}
                className="d-flex flex-lg-column flex-xs-row flex-wrap"
                style={{ fontSize: "18px" }}
              >
                <Col xs={12} lg={12}>
                  <h5>Categories</h5>
                  {renderCategories(categories1)}
                  <hr className="d-lg-block d-none me-4" />
                </Col>

              </Col>
              <Col lg={10}>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <div className="accordion-button row m-0 p-0"> {/* Flex row header without extra spacing */}
                        <div className="col-1 text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </div>
                        <div className="col-1 text-center logoBtn">
                          <span className="iconLogo">RH</span>
                        </div>
                        <div className="col-10">
                          <span className="headerTitle">Retail Product Hierarchy</span>
                          <span className="subHeaderTitle">General</span>
                        </div>
                      </div>
                    </h2>

                    <div className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col xs={12} md={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Name"
                              name="organisationName"
                              placeholder=""
                              value={formInputs?.organisationName || ""}
                              // onChange={onInputChange}
                              // error={validation.organisationName}
                              disabled={true}
                            />
                          </Col>
                          <Col xs={12} md={4} className="commTopButtonRightLeftPadding">
                            {/* <InputField
                              className="inputBox"
                              label="Active"
                              name="active"
                              iconClassName="dropdownIcon"
                              // data={activeOptions}
                              placeholder="Choose"
                              value={formInputs?.active || ""}
                              // onChange={onInputChange}
                              // getvalue={setDropdownData}
                              // error={validation.active}
                              disabled={true}
                            /> */}
                            <div class="form-check form-switch d-flex row">
                              <label className="fw-medium">
                                Active
                              </label>
                              <div className="d-flex">
                                <span className="pr-4">
                                  {formInputs?.active}
                                </span>
                                <div className="ml-5 pl-5" >

                                  <input
                                    className="form-check-input ml-4 pl-4"
                                    type="checkbox"
                                    role="switch"

                                    // id={`switch-${formInputs.local_id}`}
                                    checked={formInputs?.active === "Yes"}
                                  // onChange={(event) => handleCheckboxChange(row.local_id, event)}
                                  />
                                </div>
                              </div>
                            </div>

                          </Col>
                          <Col xs={12} md={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Modified Date"
                              type="date"
                              name="modifiedDate"
                              placeholder=""
                              value={formInputs?.modifiedDate || ""}
                              disabled={true}

                            />
                          </Col>
                          <Col xs={12} md={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Friendly Name"
                              name="friendlyName"
                              placeholder=""
                              value={formInputs?.friendlyName || ""}
                              // onChange={onInputChange}
                              // error={validation.city}
                              disabled={true}
                            />
                          </Col>
                          <Col xs={12} md={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Commodity Code"
                              name="commodityCode"
                              placeholder=""
                              value={formInputs?.commodityCode || ""}
                              // onChange={onInputChange}
                              // error={validation.commodityCode}
                              disabled={true}
                            />
                          </Col>
                          <Col xs={12} md={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Activated Date"
                              type="date"
                              name="activatedDate"
                              placeholder=""
                              value={formInputs?.activatedDate || ""}
                              // onChange={onInputChange}
                              // error={validation.activatedDate}
                              disabled={true}
                            />
                          </Col>
                          <Col xs={12} md={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Description"
                              name="generalDescription"
                              placeholder=""
                              value={formInputs?.generalDescription || ""}
                              // onChange={onInputChange}
                              // error={validation.generalDescription}
                              disabled={true}
                            />
                          </Col>
                          <Col xs={12} md={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Search Text"
                              name="searchText"
                              placeholder=""
                              value={formInputs?.searchText || ""}
                              // onChange={onInputChange}
                              // error={validation.searchText}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Retail Product Properties */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility1}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">RP</span>
                        </Col>
                        <Col xs={8} md={8} lg={8}>
                          <span className="headerTitle">Retail Product Properties </span>
                          <span className="subHeaderTitle">Global</span>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                        }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Variant Groups"
                              name="variantGroups"
                              placeholder=""
                              value={formInputs?.variantGroups || ""}
                              // onChange={onInputChange}
                              // error={validation.variantGroups}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Wash & Care"
                              name="washAndCare"
                              placeholder=""
                              value={formInputs?.washAndCare || ""}
                              // onChange={onInputChange}
                              // error={validation.washAndCare}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* <InputField
                              className="inputBox"
                              label="Matrix Layout"
                              name="matrixLayout"
                              iconClassName="dropdownIcon"
                              // data={activeOptions}
                              placeholder="Use Matrix"
                              value={formInputs?.matrixLayout || ""}
                              // onChange={onInputChange}
                              // error={validation.matrixLayout}
                              // getvalue={setDropdownData}
                              disabled={true}
                            /> */}
                            <div class="form-check form-switch d-flex row">
                              <label className="fw-medium">
                                Matrix Layout
                              </label>
                              <div className="d-flex">
                                <span className="pr-4">
                                  {formInputs?.matrixLayout}
                                </span>
                                <div className="ml-5 pl-5" >

                                  <input
                                    className="form-check-input ml-4 pl-4"
                                    type="checkbox"
                                    role="switch"

                                    // id={`switch-${formInputs.local_id}`}
                                    checked={formInputs?.matrixLayout === "Yes"}
                                  // onChange={(event) => handleCheckboxChange(row.local_id, event)}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Show Colors"
                              name="showColors"
                              placeholder=""
                              value={formInputs?.showColors || ""}
                              // onChange={onInputChange}
                              error={validation.showColors}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Size Curve"
                              name="showFiles"
                              placeholder=""
                              value={formInputs?.sizeCurve || ""}
                              // onChange={onInputChange}
                              error={validation.sizeCurve}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Color Group"
                              name="colorGroup"
                              placeholder=""
                              value={formInputs?.colorGroup || ""}
                              // onChange={onInputChange}
                              error={validation.colorGroup}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Product Brands"
                              name="productBrands"
                              placeholder=""
                              value={formInputs?.productBrands || ""}
                              // onChange={onInputChange}
                              error={validation.productBrands}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Show Sizes"
                              name="showSizes"
                              placeholder=""
                              value={formInputs?.showSizes || ""}
                              // onChange={onInputChange}
                              error={validation.showSizes}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Show Files"
                              name="showFiles"
                              placeholder=""
                              value={formInputs?.showFiles || ""}
                              // onChange={onInputChange}
                              error={validation.showFiles}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Color Curve"
                              name="colorCurve"
                              placeholder=""
                              value={formInputs?.colorCurve || ""}
                              // onChange={onInputChange}
                              error={validation.colorCurve}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Fit Group"
                              name="fitGroup"
                              placeholder=""
                              value={formInputs?.fitGroup || ""}
                              // onChange={onInputChange}
                              error={validation.fitGroup}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* <InputField
                              className="inputBox"
                              label="Ratio Curves"
                              name="ratioCurves"
                              placeholder="Use Ratio Curves"
                              iconClassName="dropdownIcon"
                              // getvalue={setDropdownData}
                              data={activeOptions}
                              value={formInputs?.ratioCurves || ""}
                              // onChange={onInputChange}
                              // error={validation.ratioCurves}
                              disabled={true}
                            /> */}
                            <div class="form-check form-switch d-flex row">
                              <label className="fw-medium">
                                Active
                              </label>
                              <div className="d-flex">
                                <span className="pr-4">
                                  {formInputs?.ratioCurves}
                                </span>
                                <div className="ml-5 pl-5" >

                                  <input
                                    className="form-check-input ml-4 pl-4"
                                    type="checkbox"
                                    role="switch"

                                    // id={`switch-${formInputs.local_id}`}
                                    checked={formInputs?.ratioCurves === "Yes"}
                                  // onChange={(event) => handleCheckboxChange(row.local_id, event)}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Fit Curve"
                              name="fitCurve"
                              placeholder=""
                              value={formInputs?.fitCurve || ""}
                              // onChange={onInputChange}
                              error={validation.fitCurve}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Legal Embity Specific */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">LS</span>
                        </Col>
                        <Col xs={8} md={8} lg={8}>
                          <span className="headerTitle">Legal Entity Specific  </span>
                          <span className="subHeaderTitle">View For All Legal Entities</span>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                        }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Legal Entity"
                              name="legalEntity"
                              placeholder=""
                              value={formInputs?.legalEntity || ""}
                              // onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* <InputField
                              className="inputBox"
                              label="Variant"
                              name="variant"
                              placeholder="Print Variant Shiels Labels"
                              // data={activeOptions}
                              iconClassName="dropdownIcon"
                              // getvalue={setDropdownData}
                              value={formInputs?.variant || ""}
                              // onChange={onInputChange}
                              disabled={true}
                            /> */}
                            <div class="form-check form-switch d-flex row">
                              <label className="fw-medium">
                                Active
                              </label>
                              <div className="d-flex">
                                <span className="pr-4">
                                  {formInputs?.variant}
                                </span>
                                <div className="ml-5 pl-5" >

                                  <input
                                    className="form-check-input ml-4 pl-4"
                                    type="checkbox"
                                    role="switch"

                                    // id={`switch-${formInputs.local_id}`}
                                    checked={formInputs?.variant === "Yes"}
                                  // onChange={(event) => handleCheckboxChange(row.local_id, event)}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* <InputField
                              className="inputBox"
                              label="Bar Code"
                              name="barCode"
                              iconClassName="dropdownIcon"
                              // data={activeOptions}
                              placeholder="Use Ean Standard Bar Code"
                              value={formInputs?.barCode || ""}
                              // onChange={onInputChange}
                              // error={validation.barCode}
                              // getvalue={setDropdownData}
                              disabled={true}
                            /> */}
                            <div class="form-check form-switch d-flex row">
                              <label className="fw-medium">
                                Bar Code
                              </label>
                              <div className="d-flex">
                                <span className="pr-4">
                                  {formInputs?.barCode}
                                </span>
                                <div className="ml-5 pl-5" >

                                  <input
                                    className="form-check-input ml-4 pl-4"
                                    type="checkbox"
                                    role="switch"

                                    // id={`switch-${formInputs.local_id}`}
                                    checked={formInputs?.barCode === "Yes"}
                                  // onChange={(event) => handleCheckboxChange(row.local_id, event)}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Pos Registers"
                              name="posRegister"
                              iconClassName="dropdownIcon"
                              // data={POSoptions}
                              // placeholder="Key In Price"
                              value={formInputs?.posRegister || ""}
                              // onChange={onInputChange}
                              // getvalue={setDropdownData}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Matrix Item Coverage"
                              name="matrixItemCoverage"
                              // iconClassName="dropdownIcon"
                              // data={MatrixItemOptions}
                              placeholder="Horizental Axis"
                              value={formInputs?.matrixItemCoverage || ""}
                              // onChange={onInputChange}
                              // getvalue={setDropdownData}
                              disabled={true}

                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Seasons"
                              name="seasons"
                              placeholder=""
                              value={formInputs?.seasons || ""}
                              // onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Comparison Price "
                              name="comparisonPrice"
                              placeholder="Base Comparison Unit"
                              value={formInputs?.comparisonPrice || ""}
                              // onChange={onInputChange}
                              // error={validation.comparisonPrice}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default ProductArticle;
